import type { DefaultModalType } from '@chat-types/common';
import Modal from '@components/modal/Modal';
import strings from '@i18n/index';
import useModalHook from '@hooks/useModalHook';
import CloseBtn from '@components/common/buttons/CloseBtn';
import Icon from '@components/common/Icon';
import { sendBirdSelectors, useSendbirdStateContext } from '@sendbird/uikit-react';
import useCurrentChannel from '@stores/currentChannelStore';
import useControlOpenPanels from '@stores/controlOpenPanelsStore';

export type LeaveModalLabel = 'leaveModal';
export type LeaveModalProps = DefaultModalType;

const LeaveModal = ({ onConfirm, onCancel }: LeaveModalProps) => {
  const { closeModal } = useModalHook();
  const globalStore = useSendbirdStateContext();
  const changeOpenChannelSettings = useControlOpenPanels((state) => state.changeOpenChannelSettings);
  const { currentChannel, clearCurrentChannel } = useCurrentChannel();
  const leaveGroupChannel = sendBirdSelectors.getLeaveGroupChannel(globalStore);

  const confirmHandler = async () => {
    try {
      await leaveGroupChannel(currentChannel!.url);
      onConfirm?.();
      clearCurrentChannel();
      changeOpenChannelSettings(false);
    } catch (error) {
      // MARK : error 처리 해줘야 합니다.
      // console.warn('error :::: ', error);
    }

    closeModal('leaveModal');
  };

  return (
    <Modal
      title={strings.CHANNEL__LEAVE_THIS_CHANNEL}
      onConfirm={confirmHandler}
      onCancel={() => {
        onCancel?.();
        closeModal('leaveModal');
      }}
      isConfirmError
      subChildren={
        <CloseBtn>
          <Icon size="24px" icon="IcClose" />
        </CloseBtn>
      }
      onSubAction={() => {
        onCancel?.();
        closeModal('leaveModal');
      }}
    />
  );
};

export default LeaveModal;
